export default __webpack_public_path__ + "static/media/96.d97ffdd8.jpg";